// CSS order first (before JS)
import 'vuetify/styles/core'
// Material color classes (bg-grey-lighten-3, text-grey-darken-4, …) — the
// legacy views use them; the old app got them via the full 'vuetify/styles'
// bundle.
import 'vuetify/styles/colors'
import 'vuetify/styles/utilities'

import 'unfonts.css'
import '@mdi/font/css/materialdesignicons.css'
import 'flag-icons/css/flag-icons.min.css'
import './styles/main.css'
// LEGACY: shared styles for the unmigrated src_old views (typography utility
// classes, app-width, …). Trimmed away as views migrate.
import '@old/styles/main.scss'

// Side-effect plugins — self-register against the consent registry.
// google_analytics has no ada-app-ui counterpart and must not be dropped.
import './plugins/datadog'
import './plugins/survicate'
import './plugins/google_analytics'
import { initOneTrust } from './plugins/onetrust'

import { createApp } from 'vue'
import router from './router'
import vuetify, { rulesPlugin } from './plugins/vuetify'
import head from './plugins/unhead'
import i18n from './plugins/i18n'
import { VueQueryPlugin, vueQueryOptions } from './plugins/vue-query'
import { createVPhoneInput, selectPhoneCountryInput, VPhoneCountryFlagSvg } from 'v-phone-input'
import pinia from './plugins/pinia'
import { eventBus, $eventBusKey } from './utils/eventBus'
import App from './App.vue'
import './utils/pwa'

// LEGACY: the old Vuex store must stay registered — the bridge getters and
// useLegacyBootstrap read/write it, and old views crash without it.
import { store } from '@old/store'

initOneTrust()

export const app = createApp(App)

// LEGACY: required by old components until they're migrated
app.config.globalProperties.$event_bus = eventBus
app.provide($eventBusKey, eventBus)

// pinia before mount is the hard requirement; pinia + store are
// registered first to make the bridge dependency explicit.
app
  .use(pinia)
  .use(store)
  .use(router)
  .use(i18n)
  .use(vuetify)
  .use(rulesPlugin)
  .use(head)
  .use(VueQueryPlugin, vueQueryOptions)
  // v-phone-input v7 renders no country selector without the plugin.
  // FlagSvg emits flag-icons classes (fi fi-se) — the CSS imported above;
  // same rendering as the old country-icon-mode="svg". (FlagSprite would
  // need a separate f32 sprite sheet we don't ship.)
  .use(
    createVPhoneInput({
      ...selectPhoneCountryInput,
      countryDisplayComponent: VPhoneCountryFlagSvg,
    })
  )

app.mount('#app')
